import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FormGroup, Input } from 'reactstrap'
import { saveToolbox } from 'store/AddWidget/actions'

function SyncChangesForm({ toolbox, dashboardId }) {
  const dispatch = useDispatch()
  const { adminToolbox, managerToolbox, employeeToolbox } = useSelector(
    (store) => store.addWidget
  )
  const [toolboxArray, setToolboxArray] = useState([])
  const [name, setName] = useState(toolbox.name)
  const [height, setHeight] = useState(toolbox.layout.h)
  const [width, setWidth] = useState(toolbox.layout.w)
  const [xPosition, setXPosition] = useState(toolbox.layout.x)
  const [yPosition, setYPosition] = useState(toolbox.layout.y)

  const newToolbox = {
    id: toolbox.id,
    name,
    active: 'false',
    layout: {
      h: height,
      w: width,
      x: xPosition,
      y: yPosition,
      i: toolbox.id,
      moved: '0',
      static: '0',
    },
  }

  useEffect(() => {
    if (dashboardId === 1) {
      setToolboxArray(adminToolbox)
    } else if (dashboardId === 2) {
      setToolboxArray(managerToolbox)
    } else if (dashboardId === 3) {
      setToolboxArray(employeeToolbox)
    }
  }, [adminToolbox, managerToolbox, employeeToolbox, dashboardId])

  const newToolboxObject = [...toolboxArray, newToolbox]

  return (
    <div className='h-fit my-2 border shadow-lg rounded-lg p-3'>
      <h2>{toolbox.name} Widget</h2>
      <FormGroup className='ml-0'>
        <label className='form-control-label' htmlFor='toolboxId'>
          Id
        </label>
        <Input
          id='toolboxId'
          readOnly
          name='id'
          type='text'
          style={{ height: '37px' }}
          value={toolbox.id}
        />
      </FormGroup>
      <FormGroup className='ml-0'>
        <label className='form-control-label' htmlFor='toolboxName'>
          Name
        </label>
        <Input
          id='toolboxName'
          name='last_name'
          type='text'
          style={{ height: '37px' }}
          onChange={(e) => setName(e.target.value)}
          defaultValue={toolbox.name}
        />
      </FormGroup>
      <div
        className='custom-control custom-checkbox mb-3'
        style={{ zIndex: '0' }}
      >
        <input
          readOnly
          className='custom-control-input'
          id='secondAccess'
          checked={false}
          type='checkbox'
        />
        <label className='custom-control-label' htmlFor='secondAccess'>
          Active (Show in dashboard immediately)
        </label>
      </div>
      <h3 className='my-2'>Layout</h3>
      <FormGroup className='ml-0'>
        <label className='form-control-label' htmlFor='widgetHeight'>
          Height
        </label>
        <Input
          id='widgetHeight'
          name='last_name'
          type='text'
          style={{ height: '37px' }}
          defaultValue={height}
          onChange={(e) => setHeight(e.target.value)}
        />
      </FormGroup>
      <FormGroup className='ml-0'>
        <label className='form-control-label' htmlFor='widgetWidth'>
          Width
        </label>
        <Input
          id='widgetWidth'
          name='last_name'
          type='text'
          style={{ height: '37px' }}
          defaultValue={width}
          onChange={(e) => setWidth(e.target.value)}
        />
      </FormGroup>
      <FormGroup className='ml-0'>
        <label className='form-control-label' htmlFor='xPosition'>
          xPosition
        </label>
        <Input
          id='xPosition'
          name='last_name'
          type='text'
          style={{ height: '37px' }}
          defaultValue={xPosition}
          onChange={(e) => setXPosition(e.target.value)}
        />
      </FormGroup>
      <FormGroup className='ml-0'>
        <label className='form-control-label' htmlFor='yPosition'>
          yPosition
        </label>
        <Input
          id='yPosition'
          name='last_name'
          type='text'
          style={{ height: '37px' }}
          defaultValue={yPosition}
          onChange={(e) => setYPosition(e.target.value)}
        />
      </FormGroup>
      <h4>Highly advisable to not change values!!!</h4>
      <button
        onClick={() =>
          dispatch(
            saveToolbox(dashboardId, newToolboxObject, newToolbox, 'sync')
          )
        }
        className='btn btn-info'
      >
        Add Widget
      </button>
    </div>
  )
}

export default SyncChangesForm
